// src/utils/notificaciones.js
// Emails automáticos via EmailJS — complemento al WhatsApp
import emailjs from "@emailjs/browser";

const SVC  = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const PUB  = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

const TEMPLATES = {
  pedido:       process.env.REACT_APP_EMAILJS_TPL_PEDIDO,
  pago:         process.env.REACT_APP_EMAILJS_TPL_PAGO,
  cotizacion:   process.env.REACT_APP_EMAILJS_TPL_COTIZACION,
  entrega:      process.env.REACT_APP_EMAILJS_TPL_ENTREGA,
};

async function enviarEmail(templateKey, params) {
  if (!SVC || !PUB || !TEMPLATES[templateKey]) return;
  try {
    await emailjs.send(SVC, TEMPLATES[templateKey], params, PUB);
  } catch (e) {
    console.error("EmailJS error:", e);
  }
}

// Email confirmación de pedido
export async function emailPedidoConfirmado(cliente, pedido) {
  await enviarEmail("pedido", {
    to_name:    cliente.nombre,
    to_email:   cliente.email,
    empresa:    cliente.empresa,
    pedido_num: pedido.numero,
    materiales: pedido.materiales,
    valor:      `S/ ${Number(pedido.valor).toLocaleString()}`,
    fecha:      pedido.fechaEntrega,
    transporte: pedido.transporte || "Por asignar",
  });
}

// Email recordatorio de pago
export async function emailRecordatorioPago(cliente, factura) {
  await enviarEmail("pago", {
    to_name:    cliente.nombre,
    to_email:   cliente.email,
    factura_num: factura.numero,
    monto:      `S/ ${Number(factura.monto).toLocaleString()}`,
    vencimiento: factura.fechaVencimiento,
    cuenta_bcp:  process.env.REACT_APP_CUENTA_BCP || "[Tu cuenta BCP]",
  });
}

// Email cotización
export async function emailCotizacion(cliente, items) {
  const detalles = items.map(i =>
    `${i.cantidad} ${i.unidad} de ${i.material} — S/ ${i.precio}`
  ).join("\n");
  const total = items.reduce((s, i) => s + i.precio, 0);
  await enviarEmail("cotizacion", {
    to_name:   cliente.nombre,
    to_email:  cliente.email,
    empresa:   cliente.empresa,
    detalles,
    total:     `S/ ${total.toLocaleString()}`,
    validez:   "7 días",
  });
}

// Email confirmación de entrega
export async function emailEntregaConfirmada(cliente, pedido) {
  await enviarEmail("entrega", {
    to_name:    cliente.nombre,
    to_email:   cliente.email,
    pedido_num: pedido.numero,
    materiales: pedido.materiales,
    hora:       new Date().toLocaleTimeString("es-PE", { hour: "2-digit", minute: "2-digit" }),
  });
}

